import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaProps } from '../media-constant';
import { renderVocabCard } from './renderElement';
import { VocabCardReadOnlyPlugin } from './VocabCardReadOnlyPlugin';

export const VocabCardPlugin = (props?: MediaProps): SlatePlugin => {
  if (props.isPreview) {
    return VocabCardReadOnlyPlugin(props);
  }
  return {
    renderElement: renderVocabCard(props),
  };
};
